export function extractDomainZone(url: string, domains?: string[]) {
  const hostname = url.replace(/^https?:\/\/(www\.)?/, '').replace(/[/?].*$/, '')

  if (domains && domains.length > 0) {
    const sortedDomains = [...domains].sort((a, b) => b.length - a.length)

    for (const domain of sortedDomains) {
      if (hostname.endsWith(domain)) {
        return domain
      }
    }
  }

  return hostname.slice(hostname.indexOf('.'))
}
